import React from 'react';
import { setCurrentView } from 'core/utils';
import { OrderDateRangeViewStore } from 'modules/order/stores';
import { OrderDateRangeFilterTemplate } from 'themes/modules/order/pages';


class OrderDateRangeFilter extends React.Component{
    constructor(props) {
        super(props);
    }

	render() {
		return <OrderDateRangeFilterTemplate {...this.props} />;
	}
}

export default OrderDateRangeFilter;



// WEBPACK FOOTER //
// ./src/modules/order/pages/OrderDateRangeFilter.jsx